<template>
    <div class="row">
        <div class="col-12" :class="{'mb-1':value.ChangeType != 0}" v-if="editing">
            <label class="form-label">Değişiklik Türü</label>
            <select class="form-control" v-model="value.ChangeType">
                <option :value="0">Seçiniz</option>
                <option v-for="ct in c_changeTypes" :key="ct.value" :value="ct.value">{{ ct.type }}</option>
            </select>
        </div>
        <div class="col-12 mb-1" v-if="showBranch">
            <label class="from-label">Şube</label>
            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="showTitle">
            <label class="from-label">Unvan</label>
            <v-select-list :disabled="value.BranchId == null" :options="titles" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="isDriver && showVehicleInventoryGarage">
            <label class="form-label">Görev Yeri</label>
            <v-select-list :disabled="value.BranchId == null" :options="vehicleInventoryGarages" label="GarageName" v-model="vehicleInventoryGarage" placeholder="Görev Yeri"></v-select-list>
        </div>
        <div class="col-12" v-if="showDate">
            <label class="form-label">Atama Tarihi</label>
            <v-date-picker v-model="value.Date" placeholder="Atama Tarihi"></v-date-picker>
        </div>
    </div>
</template>

<script>
import VehicleOperationsApi from '@/api/vehicle-operations'
import CompanyApi from '@/api/company'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import moment from 'moment'
export default {
    props:{
        value:Object,
        editing:Boolean
    },
    data() {
        return {
            branches:[],
            titles:[],
            vehicleInventoryGarages:[],
            changeTypes:[
                {type:'Şube Değişikliği',value:1},
                {type:'Garaj Değişikliği',value:2},
                {type:'Unvan Değişikliği',value:3}
            ]
        }
    },
    mounted(){
        this.getBranches()
        this.getTitles()
        this.getVehicleInventoryGarages()
    },
    watch:{
        "value.ChangeType"(){
            if(this.value.ChangeType == 1) this.value.Date = this.value.BranchStartDate ? moment(this.value.BranchStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else if(this.value.ChangeType == 2) this.value.Date = this.value.GarageStartDate ? moment(this.value.GarageStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else if(this.value.ChangeType == 3) this.value.Date = this.value.TitleStartDate ? moment(this.value.TitleStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else this.value.Date = null
        },
        "value.BranchId"(){
            this.value.EmployeeDepartmentTitleId = null
            this.getTitles()
            this.getVehicleInventoryGarages()
        },
        "value.EmployeeDepartmentTitleId"(){
            this.value.VehicleInventoryGarageId = null
        }
    },
    methods:{
        getVehicleInventoryGarages(){
            if(this.value.BranchId){
                VehicleOperationsApi.Garage.ListByBranch(this.value.BranchId).then(res=>{
                    this.vehicleInventoryGarages = res.data.Data
                })
            }
        },
        getBranches(){
            CompanyApi.Branch.ListByCode('O').then(res=>{
                this.branches = res.data.Data
            })
        },
        getTitles(){
            if(this.value.BranchId){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.value.BranchId).then(res=>{
                    this.titles = res.data.Data
                })
            }
        },
    },
    computed:{
        showBranch(){
            if(this.editing){
                if(this.value.ChangeType == 1) return true
                else return false
            }else return true
        },
        showTitle(){
            if(this.editing){
                if(this.value.ChangeType == 1 || this.value.ChangeType == 3) return true
                else return false
            }else return true
        },
        showVehicleInventoryGarage(){
            if(this.editing){
                if(this.value.ChangeType == 1 || this.value.ChangeType == 2) return true
                else return false
            }else return true
        },
        showDate(){
            if(this.editing){
                if(this.value.ChangeType != 0) return true
                else return false
            }else return true
        },
        c_changeTypes(){
            if(this.isDriver){
                return this.changeTypes
            }else return this.changeTypes.filter(ct=>ct.value != 2)
        },
        isDriver(){
            if(this.title){
                return this.title.DriverDepartment || false
            }else return false
        },
        vehicleInventoryGarage:{
            get:function(){
                return this.vehicleInventoryGarages.find(b=>b.Id==this.value.VehicleInventoryGarageId)
            },
            set:function(value){
                this.value.VehicleInventoryGarageId = value?.Id || null
            }
        },
        title:{
            get:function(){
                return this.titles.find(b=>b.Id==this.value.EmployeeDepartmentTitleId)
            },
            set:function(value){
                this.value.EmployeeDepartmentTitleId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
    }
}
</script>